import styled from 'styled-components';
import loadable from '@loadable/component';
import { blockquoteCSS, getOrderedListCSS, getTextSizeCSS, tableCSS } from '../styles';
export const ReactMarkdown = loadable(() => import('react-markdown'));
export const StyledMarkdown = styled(ReactMarkdown) `
  ${({ textSize }) => getTextSizeCSS(textSize)}
  ${({ orderedListAppearance }) => getOrderedListCSS(orderedListAppearance)}
  ${blockquoteCSS}
  ${tableCSS}
`;
//# sourceMappingURL=StyledMarkdown.js.map